import { useMutation, useQuery } from '@tanstack/react-query';
import { reportsApi } from '../api/endpoints';
import { useAuthStore } from '../stores/auth.store';

export function useDashboard() {
  const account = useAuthStore((s) => s.account);

  return useQuery({
    queryKey: ['dashboard', account?.id],
    queryFn: () => reportsApi.dashboard(account!.id),
    enabled: !!account?.id,
    select: (res) => res.data,
    staleTime: 1000 * 60 * 5,
  });
}

export function useReport() {
  return useMutation({
    mutationFn: (params: {
      type: string;
      shopid?: string;
      accountid?: string;
      from: string;
      to: string;
      format?: string;
    }) => reportsApi.generate(params),
  });
}

export function useStoreSummary(shopId?: string, from?: string, to?: string) {
  const shop = useAuthStore((s) => s.shop);
  const activeShopId = shopId ?? shop?.id;

  return useQuery({
    queryKey: ['store-summary', activeShopId, from, to],
    queryFn: () => reportsApi.storeSummary(activeShopId!, { from, to }),
    enabled: !!activeShopId,
    select: (res) => res.data,
  });
}
